import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './_shell';
import './theme';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
